import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";
import Avatar from "@/components/General/Avatar";
import Link from "next/link";

export default function ParticipantModal({participantOpen, setParticipantOpen, participants}){
    //console.log(participants);
    return(
        <CWFResponsiveDialog
            open={participantOpen}
            onOpenChange={setParticipantOpen}
            title={<p>Participants</p>}
            trigger={null}
        >
            <div className={"max-h-60 overflow-y-scroll grid gap-4"}>
                {participants.length >0
                    ?
                    <>
                        {participants.map(function(participant){
                            if(participant.user.firstname && participant.user.lastname){
                                return(
                                    <div key={participant.id} className={"flex items-center gap-x-4"}>
                                        <Avatar url={participant.user.docs[0]?.path} width={50} height={50}/>
                                        <div>
                                            <Link href={`/profile/${participant.user.id}`}>
                                                <button
                                                    className={"font-medium hover:underline"}
                                                >
                                                    {participant.user.firstname} {participant.user.lastname}
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                )
                            }

                        })}
                    </>
                    :
                    <p className={"text-center text-gray-500 italic"}>
                        Il n&apos;y a pas encore de participants pour le moment...
                    </p>


                }

            </div>
        </CWFResponsiveDialog>
    )
}